// extracted by mini-css-extract-plugin
module.exports = {"alert":"useSnackbar_alert__jZCM4","closeButton":"useSnackbar_closeButton__9RLu3"};